/**
 * API 에러 메시지 상수
 *
 * axios interceptor에서 사용되는 에러 메시지를 중앙화하여 관리
 */

export const API_ERROR_MESSAGES = {
  // Network & Connection Errors
  NETWORK_ERROR: {
    message: '네트워크 오류',
    description: '서버에 연결할 수 없습니다. 네트워크 연결을 확인해주세요.',
  },
  TIMEOUT: {
    message: '요청 시간 초과',
    description: '요청 시간이 초과되었습니다. 다시 시도해주세요.',
  },

  // Authentication Errors
  AUTH_REQUIRED: {
    message: '인증 필요',
    description: '인증이 필요합니다. 로그인 페이지로 이동합니다.',
  },
  SESSION_EXPIRED: {
    message: '인증 필요',
    description: '로그인이 필요합니다. 로그인 페이지로 이동합니다.',
  },

  // HTTP Status Errors
  FORBIDDEN: {
    message: '접근 권한 없음',
    description: '해당 리소스에 접근할 권한이 없습니다.',
  },
  NOT_FOUND: {
    message: '리소스를 찾을 수 없음',
    description: '요청한 리소스를 찾을 수 없습니다.',
  },
  BAD_REQUEST: {
    message: '잘못된 요청',
    description: '요청이 올바르지 않습니다.',
  },
  SERVER_ERROR: {
    message: '서버 오류',
    description: '서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
  },
  API_ERROR: {
    message: 'API 오류',
    description: '알 수 없는 오류가 발생했습니다.',
  },
} as const;
